import { Transaction } from "@cede/types";
import { getCefiSide } from "./getCefiSide";

export const compareCefiTx = (tx1: Transaction, tx2: Transaction) => {
  return getCefiSide(tx1).transaction.transactionId === getCefiSide(tx2).transaction.transactionId;
};
